import sourcesUIStore from './sourcesUIStore.js';
import sourcesDataStore from './sourcesDataStore.js';

export default {
  modules: {
    ui: sourcesUIStore,
    data: sourcesDataStore,
  },
};
